import { useState, useCallback } from 'react';
import { foodSwaps } from '../../../data/foodSwaps';
import { searchableFoods } from '../../../data/foodDatabase';
import { FoodSwap, FoodItem } from '../types';

export function useFoodSwaps() {
  const [currentSwapIndex, setCurrentSwapIndex] = useState(0);
  const [selectedSwap, setSelectedSwap] = useState<FoodSwap | null>(null);

  const refreshSwap = useCallback(() => {
    setCurrentSwapIndex((prev) => (prev + 1) % foodSwaps.length);
  }, []);

  const searchFoods = useCallback((query: string) => {
    if (!query) return [];
    return searchableFoods.filter(food =>
      food.name.toLowerCase().includes(query.toLowerCase())
    ).slice(0, 8);
  }, []);

  const findSwapForFood = useCallback((foodName: string) => {
    let swap = foodSwaps.find(s => 
      s.from.name.toLowerCase() === foodName.toLowerCase()
    );
    
    if (!swap) {
      const searchedFood = searchableFoods.find(f => 
        f.name.toLowerCase() === foodName.toLowerCase()
      );
      
      if (searchedFood) {
        const targetCalories = searchedFood.calories * 0.7;
        const similarFoods = searchableFoods.filter(f => 
          f.calories <= targetCalories && 
          f.calories >= targetCalories * 0.5 &&
          f.name !== searchedFood.name
        );
        
        if (similarFoods.length > 0) {
          const bestMatch = similarFoods.sort((a, b) => 
            Math.abs(targetCalories - a.calories) - Math.abs(targetCalories - b.calories)
          )[0];
          
          swap = {
            from: {
              name: searchedFood.name,
              calories: searchedFood.calories,
              emoji: searchedFood.emoji
            },
            to: {
              name: bestMatch.name,
              calories: bestMatch.calories,
              emoji: bestMatch.emoji
            }
          };
        }
      }
    }
    
    return swap;
  }, []);

  const handleFoodSelect = useCallback((food: FoodItem) => {
    const swap = findSwapForFood(food.name);
    if (swap) {
      setSelectedSwap(swap);
    }
  }, [findSwapForFood]);

  return {
    currentSwap: selectedSwap || foodSwaps[currentSwapIndex],
    refreshSwap,
    searchFoods,
    handleFoodSelect
  };
}